export async function callApi(
  endpoint: string,
  requestOptions: RequestInit
): Promise<object> {
  return await fetch(endpoint, requestOptions)
    .then(async (response) => {
      if (response.ok) {
        return response.json()
      }

      let error: string | object = await response.text()

      try {
        error = JSON.parse(error)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        // do nothing
      }

      throw new Error(`New error message on API ${endpoint}`, {
        cause: error,
      })
    })
    .catch((error: Error) => {
      // eslint-disable-next-line no-console
      console.error(error)

      return { error: error.cause }
    })
}

export const deleteContributor = (
  baseURL: string,
  projectId: string,
  contributorId: string
) => {
  const payload = {
    contributorId,
    projectId,
  }

  return fetch(`${baseURL}/api/contributor`, {
    method: 'DELETE',
    body: JSON.stringify(payload),
  }).then((res) => res.json())
}
